import React from 'react'
import { IProps, ISlideProps, Carousel } from 'marketing-site/src/library/components/Carousel'
import { ICarousel, ICarouselSlide, IImage } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformImage } from '../elements/ContentfulImage'
import * as Utils from 'marketing-site/src/library/utils'

export const ContentfulCarousel = (data: ICarousel) => (
  <EntryMarker entry={data}>
    <Carousel {...transformCarousel(data)} />
  </EntryMarker>
)

export function transformCarousel({ fields }: ICarousel): IProps {
  return {
    ...fields,
    slides: fields.slides.map(transformSlide),
  }
}

export function transformSlide({ fields, sys }: ICarouselSlide): ISlideProps {
  return {
    ...fields,
    id: sys.id,
    description: fields.description,
    image: transformImage(fields.image as IImage),
    video: fields.video && fields.video?.fields.file.url,
    backgroundColor:
      fields.backgroundColor &&
      (Utils.getHexColorFromName(fields.backgroundColor) as Utils.LegacyColor | Utils.Color),
  }
}
